import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useEffect, type ReactNode } from "react";

import { BYPASS_AUTH } from "@/auth/devBypass";
import { loginRequest } from "@/auth/msalConfig";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const isAuth = useIsAuthenticated();
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    if (BYPASS_AUTH) return;
    if (!isAuth && inProgress === "none") {
      instance.loginRedirect(loginRequest).catch((e) => {
        console.error("loginRedirect falhou:", e);
      });
    }
  }, [isAuth, inProgress, instance]);

  if (BYPASS_AUTH) return <>{children}</>;
  if (!isAuth) {
    return (
      <div className="grid min-h-screen place-items-center">
        <div className="text-ink-muted">Redirecionando para o login…</div>
      </div>
    );
  }
  return <>{children}</>;
}
